import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals, Ref } from '../globals';
import { PrVnta } from './product-vnta.service';

export interface Teacher {
  active: boolean;
  createdAt: any;
  updatedAt: any;

  name: string;
  family: string;
  birthdate: string;
  semester: number;
  assignments: string[];

  //prVntaRef: Ref;
}

interface TeacherId extends Teacher {
  id: string;
  //prVntaObj: PrVnta;
}

@Injectable()
export class TeacherService {

  teacherCollection: AngularFirestoreCollection<Teacher>;
  teachers: any;

  teacherDocument: AngularFirestoreDocument<TeacherId>;
  teacher: Observable<TeacherId>;

  collection: string;
  //prVntaCollection: string;

  // NOTE: Change this any for Teacher Interface
  teacher$: Observable<any>;
  teachers$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.TEACHER_COLLECTION;
    //this.prVntaCollection = Globals.PRVNTA_COLLECTION;
  }

  /**
   * Get all teachers with references
   * @return {Observable} Arrays of teachers
   */
  getTeachers(): Observable<TeacherId[]> {
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
  }

  /**
  * Get teacher data
  * @param {string} sid - The id of the teacher
  * @return {Observable} The Teacher Object
  */
  getTeacher(sid: string): Observable<TeacherId> {
  // getTeacher(sid: string): Observable<TeacherId[]> {
    return this.afh.docWithIds$(this.collection + '/' + sid);
/*
    return this.afh.docWithIds$(this.collection + '/' + sid).map((document: TeacherId) => {
        const prVntaRef = this.afh.docWithIds$(`${document.prVntaRef.path}`);
        return Observable.combineLatest(
          prVntaRef,
          (prVntaData) => ({ prVnta: prVntaData })
        ).map(data => ({ prVntaObj: data.prVnta, ...document }) );
      }).mergeMap(docs => Observable.combineLatest(docs));
      */
  }

  /**
  * Create new teacher
  * @param {Teacher} teacher - The data of the teacher
  */
  addTeacher(teacher: Teacher) {
    this.afh.add(`${this.collection}`, teacher);
  }

  /**
   * Update current teacher
   * @param {string} sid  - The id of the teacher
   * @param {Teacher} teacher - The data of the teacher
   */
  updateTeacher(sid: string, teacher: Teacher) {
    this.afh.update(`${this.collection}/${sid}`, teacher);
  }

  /**
   * Delete current teacher
   * @param {string} sid - The id of the teacher
   */
  deleteTeacher(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

 /*
  prVntaReference(id: string) {
    return this.afh.doc(`${this.prVntaCollection}/${id}`).ref;
  }
*/
  windowReplace(action: string, id?: string){
    switch(action) {
      case 'add':
      case 'create':
        this.router.navigate([`/new_teacher`]);
        break;
      case 'edit':
      case 'update':
        this.router.navigate([`/edit_teacher/${id}`]);
        break;
      case 'view':
      case 'display':
        this.router.navigate([`/vw_teacher/${id}`]);
        break;
      case 'read':
        this.router.navigate([`/teacher`]);
        break;
      default:
        console.log('Not an action');
    }
  }
}

export class TeacherData {
  assignments = {
    key0: 'Online',
    key1: 'Offline',
    key2: 'none',
  }
}
